module.exports = __webpack_public_path__ + "static/media/reformer7.5311b946.jpg";